export class DateUtil {
    public static getDateFromValue(value: any): Date;
    public static getDateFromValue(value: any, adjustForLocale: boolean): Date;
    public static getDateFromValue(value: any, adjustForLocale?: boolean): Date {
        if (typeof (value == "string")) {
            const date = new Date(value)
            if ((adjustForLocale == undefined)
                || (adjustForLocale)) {
                return new Date(date.getTime() + ((date.getTimezoneOffset() * -1) * 60000));
            } else {
                return date;
            }
        } else {
            // Assume value is of type Date.
            return value as Date;
        }
    }

    public static adjustDate(date: Date, days: number): Date {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    public static getDateOnlyISOString(date: Date): String {
        return date.toISOString().split("T")[0];
    }
}